module.exports = __webpack_public_path__ + "img/logo1.fecd6d8f.png";